import { Card } from "../../models/card";
import { decks } from "../../state";
import { Forest } from "../../decks/forest";
export class Bridge extends Card {
}
Bridge.displayName = "Bridge";
Bridge.artUrl = "./assets/cards/bridge.jpg";
Bridge.effect = {
    callback: () => {
        decks.find((deck) => deck instanceof Forest).addNextCard();
    },
    description: "Adds a card to the Forest Deck",
    needsFeedback: true,
};
Bridge.destroysOnPlay = true;
